import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import Button from '@hellodarwin/core/lib/components/common/button';
import { useAnnualRevenue, useCompanySize, } from '@hellodarwin/core/lib/features/helpers/company-infos';
import useLocale from '@hellodarwin/core/lib/features/providers/locale-provider';
import Locked from '@hellodarwin/icons/dist/icons/Locked';
import { useCallback, useMemo, useState, } from 'react';
import { useTheme } from 'styled-components';
import { usePremiumAccess } from '../../providers';
import CompanyInfoModal from '../company-info-modal';
import { resolveMarketingButton } from './resolver';
import { getMarketingButtonStyle } from './styles';
const MarketingControlledButton = ({ type, company, admin, openMeetingModalClicked, updateCompany, industrySectors, legalStructures, fullWidth, size, style, }) => {
    var _a;
    const { selectedLocale } = useLocale();
    const { accessLevel, handleCheckout } = usePremiumAccess();
    const [showCompanyModal, setShowCompanyModal] = useState(false);
    const theme = useTheme();
    const revenueOptions = useAnnualRevenue();
    const sizeOptions = useCompanySize();
    const config = useMemo(() => {
        return resolveMarketingButton(type, selectedLocale, accessLevel, company, admin, handleCheckout);
    }, [type, selectedLocale, accessLevel, company, admin]);
    const isCompanyInfoMissing = useMemo(() => {
        if (!company)
            return true;
        return (!company.annual_revenue ||
            !company.legal_structure ||
            !company.province ||
            !company.industry_sector ||
            company.industry_sector.length === 0);
    }, [
        company === null || company === void 0 ? void 0 : company.annual_revenue,
        company === null || company === void 0 ? void 0 : company.legal_structure,
        company === null || company === void 0 ? void 0 : company.province,
        company === null || company === void 0 ? void 0 : company.industry_sector,
    ]);
    const handleClick = (event) => {
        event === null || event === void 0 ? void 0 : event.preventDefault();
        event === null || event === void 0 ? void 0 : event.stopPropagation();
        if (!config)
            return;
        if (isCompanyInfoMissing && updateCompany) {
            setShowCompanyModal(true);
            return;
        }
        if (config === null || config === void 0 ? void 0 : config.action) {
            config.action();
        }
        else {
            window.open((config === null || config === void 0 ? void 0 : config.link) || '/', '_blank');
        }
        openMeetingModalClicked === null || openMeetingModalClicked === void 0 ? void 0 : openMeetingModalClicked(type);
    };
    const handleCompanySubmit = useCallback(async (values) => {
        setShowCompanyModal(false);
        if (updateCompany) {
            const updatedCompany = Object.assign(Object.assign({}, company), values);
            const data = new FormData();
            data.append('request', JSON.stringify(updatedCompany));
            await updateCompany(data);
        }
    }, [updateCompany, company]);
    if (!(config === null || config === void 0 ? void 0 : config.title))
        return null;
    return (_jsxs(_Fragment, { children: [_jsx(Button, { fullWidth: fullWidth, size: size, style: getMarketingButtonStyle({
                    type,
                    isLocked: config === null || config === void 0 ? void 0 : config.isLocked,
                    theme,
                    style,
                }), variant: config === null || config === void 0 ? void 0 : config.variant, onClick: handleClick, trailingIcon: (config === null || config === void 0 ? void 0 : config.isLocked) ? _jsx(Locked, { size: 16 }) : undefined, children: (_a = config === null || config === void 0 ? void 0 : config.title) !== null && _a !== void 0 ? _a : 'Parler à un expert' }), _jsx(CompanyInfoModal, { open: showCompanyModal, onClose: () => setShowCompanyModal(false), onSave: handleCompanySubmit, company: company, options: {
                    industryOptions: industrySectors,
                    legalStructOptions: legalStructures,
                    revenueOptions,
                    sizeOptions,
                } })] }));
};
export default MarketingControlledButton;
